import Colors from "../../../theme/colors";

const styles = {
  mainContainer: {
    flex: 6,
    // padding: "0 1rem",
    background: "#F7F7F9 0% 0% no-repeat padding-box",
  },
  main: {
    flex: 4,
    padding: "0 1rem",
  },
  rightAside: {
    flex: 2,
    paddingRight: "1rem",
    display: "flex",
    flexDirection: "column",
    gap: "2rem",
  },
  cardContainer: {
    display: "flex",
    gap: "0.8rem",
    marginBottom: "2rem",
  },
  appointment: {
    padding: "0 1rem 0.5rem",
  },
  tableHeadCell: {
    padding: "0 1rem",
    color: "#8C8C8C",
    fontWeight: 600,
  },
  tableRowCell: {
    borderBottom: "unset",
  },
  status: {
    backgroundColor: "#E8FFDB",
    border: "1px solid #1C9C29",
    borderRadius: 12,
    padding: "2px 12px",
  },
  attandence: {
    display: "flex",
    gap: "1rem",
    padding: "0 1rem",
    flex: 1,
  },
  attandenceTable: {
    flex: 1,
  },
  attendanceTableHeading: {
    paddingBottom: "0.5rem",
  },
  listContainer: {
    padding: "0 1rem",
  },
  item: {
    display: "flex",
    justifyContent: "space-between",
  },
  modal: {
    minHeight: 500,
    maxHeight: 700,
    width: "50%",
    overflowY: "scroll",
  },
  inputStyle: {
    height: 191,
    minWidth: "330",
    maxWidth: "400",
    // border: "1px solid #707070",
    borderRadius: "5px",
  },
  lastContainer: {
    padding: "0 1rem",
    width: "100%",
    display: "flex",
    gap: "1rem",
    flex: 1,
  },

  remarksStyle: {
    color: "#8C8C8C",
    textTransform: "uppercase",
    marginLeft: "16px",
  },
  actionBtn: {
    // backgroundColor: Colors.white,
    border: `1px solid ${Colors.midnightBlue}`,
    color: Colors.white,
    // "&:hover": {
    //   backgroundColor: Colors.white,
    //   color: Colors.hoverBlue,
    //   border: `1px solid ${Colors.hoverBlue}`,
    // },
    fontSize: "10px",
    height: "28px",
  },
  emptyContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 400,
  },
  noDataMsg: {
    color: "#515772",
  },
  tableHeadCells: {
    // padding: "8px",
    color: "#000000",
    fontWeight: 600,
    background: "#BAD9EC",
  },
};

export default styles;
